import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep, set } from 'lodash';
import { CustomerGridModel } from '../models/superbit-api-models';


interface clientsState {
    clientsData: any;

    newPolicyWithAdditionNumber: {
        policyId: string;
        additionNumber: string;
    }
}
    

const initialState: clientsState = {
    clientsData: null as any,
    newPolicyWithAdditionNumber: {
        policyId: '',
        additionNumber: '',
    },
    
}

export const clientsSlice = createSlice({
    name: 'clientsSlice',
    initialState,
    reducers: {
        setClientsData: (state, action: PayloadAction<any>) => {
            state.clientsData = action.payload;
        },
        setNewPolicyWithAdditionNumber: (state, action: PayloadAction<{policyId: string; additionNumber: string;}>) => {
            state.newPolicyWithAdditionNumber = action.payload;
        },
    },
})
export const { setClientsData, setNewPolicyWithAdditionNumber } = clientsSlice.actions
export default clientsSlice.reducer